import React from "react";
import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import prototypes from "../data/prototypes";

export default function PrototipoPage() {
    const { id } = useParams();
    const proto = prototypes.find((p) => p.id === id);
    if (!proto) return <div>Prototipo no encontrado</div>;

    return (
        <div className="dark:bg-gray-800 py-16 container mx-auto mt-24">
            <Helmet>
                <title>{proto.name} ~ Antigua Finca San Cristobal</title>
            </Helmet>
            <div className="text-center pb-12">
                <h3 className="mt-2 text-3xl leading-8 tracking-tight sm:text-4xl constantine text-center pb-5">
                    <span className="block bg-gradient-to-r from-brown via-corn to-mule dark:from-corn dark:via-white dark:to-corn bg-clip-text text-transparent">
                        {proto.name}
                    </span>
                </h3>
                <h1 className="text-center volk font-light text-2xl uppercase">
                    <span className="block bg-gradient-to-r from-elf via-elf to-cyprus dark:from-elf dark:via-elf dark:to-white bg-clip-text text-transparent uppercase">
                        {proto.description}
                    </span>
                </h1>
            </div>
            <div className="grid grid-cols-1 xl:grid-cols-2 gap-4">
                <div className="mx-auto">
                    <img src={proto.image} alt={proto.name} className="max-w-lg mx-auto" />
                </div>
                <div>
                    <div className="pt-12 p-5 lg:p-10">
                        <h3 className="text-3xl text-center pb-5">
                            <span className="block bg-gradient-to-r from-brown via-corn to-mule bg-clip-text text-transparent">
                                Modelo de la casa
                            </span>
                        </h3>
                        <h1 className="text-center volk font-light text-2xl uppercase">
                            Conoce el diseño de este prototipo
                        </h1>
                        <div className="mt-10 md:grid gap-4 md:grid-cols-2">
                            {proto.features.map((feature, index) => (
                                <div key={index} className="p-2 rounded hover:bg-tango-500 hover:text-white cursor-pointer text-gray-700 dark:text-gray-300">
                                    <feature.icon className="text-tango-500 -mt-1" />
                                    <span className="p-2 mt-2 raleway">{feature.text}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

